export default function Conditional({show, children}) {
  if (!show) return null;
  return children;
}